import { bindDialog, BindDialogReturn, DialogProps, DialogResult, DialogState, useDialogState } from "../../hooks/use-dialog-state/UseDialogState";
import FullScreenDialog, { FullScreenDialogCloseReason } from "../full-screen-dialog/FullScreenDialog";
import ScheduledReportsEditor from "./ScheduledReportsEditor";

import type { JSX } from "react";

export type ScheduledReportsEditorDialogInitValues = {
    organizationID: number;
    groupID: number;
    taskID: number;
    myReports: boolean;
    copy?: boolean;
};

export type ScheduledReportsEditorDialogResultValues = {
    taskID: number | undefined;
};

export type ScheduledReportsEditorDialogResultReason = FullScreenDialogCloseReason | "cancel" | "save";

export type ScheduledReportsEditorDialogResult = DialogResult<ScheduledReportsEditorDialogResultValues, ScheduledReportsEditorDialogResultReason>;

export type ScheduledReportsEditorDialogProps = DialogProps<ScheduledReportsEditorDialogInitValues, ScheduledReportsEditorDialogResult>;

export default function ScheduledReportsEditorDialog({
    open,
    onClose,
    values
}: ScheduledReportsEditorDialogProps): JSX.Element {

    return (
        <FullScreenDialog open={open} onClose={reason => onClose({ reason: reason })}>
            <ScheduledReportsEditor
                organizationID={values?.organizationID as number}
                groupID={values?.groupID as number}
                taskID={values?.taskID as number}
                myReports={values?.myReports ?? false}
                copy={values?.copy as boolean}
                onClose={({
                    reason, 
                }) => onClose({
                    reason: reason,
                    values: {
                        taskID: values?.taskID
                    }
                })}
            />
        </FullScreenDialog>
    );
}

export type ScheduledReportsEditorDialogState = DialogState<ScheduledReportsEditorDialogInitValues, ScheduledReportsEditorDialogResult>;
export type BindScheduledReportsEditorDialogReturn = BindDialogReturn<ScheduledReportsEditorDialogInitValues, ScheduledReportsEditorDialogResult>;

export function useScheduledReportsEditorDialogState(): ScheduledReportsEditorDialogState {
    return useDialogState();
}

export function bindScheduledReportsEditorDialog(props: ScheduledReportsEditorDialogState): BindScheduledReportsEditorDialogReturn {
    return bindDialog(props);
}
